var React = require('react');

function SubStatusProblem (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10.0001","cy":"10","r":"10","fill":"#EA534F","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.70717 6.29289C7.31664 5.90237 6.68348 5.90237 6.29295 6.29289C5.90243 6.68342 5.90243 7.31658 6.29295 7.70711L8.41429 9.82844L6.29298 11.9498C5.90246 12.3403 5.90246 12.9734 6.29298 13.364C6.68351 13.7545 7.31667 13.7545 7.7072 13.364L9.82851 11.2427L11.9498 13.364C12.3403 13.7545 12.9735 13.7545 13.364 13.364C13.7545 12.9734 13.7545 12.3403 13.364 11.9497L11.2427 9.82844L13.3641 7.70711C13.7546 7.31659 13.7546 6.68342 13.3641 6.2929C12.9735 5.90238 12.3404 5.90238 11.9498 6.2929L9.82851 8.41423L7.70717 6.29289Z","fill":"#FFFBE7","key":1})]);
}

SubStatusProblem.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SubStatusProblem;

SubStatusProblem.default = SubStatusProblem;
